import { Routes } from '@angular/router';
import { FullAppComponent } from './full-app/full-app.component';
import { ConfirmComponent } from './confirm/confirm.component';

export const routes: Routes = [
    { path: '', component: FullAppComponent },
    { path: 'confirm', component: ConfirmComponent },
];
